export default __webpack_public_path__ + "static/jason-bitmoji-5574371fc2acc707822caefebae5b82c.png";